import type { PackagingAttributes } from '~/types';

export const usePackagingStore = defineStore('packaging', () => {
    const packagings = ref<PackagingAttributes[]>([]);

    return {
        packagings
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(usePackagingStore, import.meta.hot));
}
